import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import Typography from "../Typography";
import VideocamIcon from '@material-ui/icons/Videocam';
import style from "./style";
import Icon from "../Icon"
import Popover from "./popover"
import ZoomLogo from "images/zoom.png"
import "./index.css"
import { parseLink } from "./utils";

const Venue = withStyles(style)(({ onTryToEdit, disabled, classes, onChange, eventType, zoomLink, meetingId, passcode, placeName, address, poupStateChange }) => {
  const openLocationInGoogleMap = (value) => {
    if (value.eventType === "virtual" && value.zoomLink) return window.open(parseLink(value.zoomLink))
    else if (value.address && value.eventType !== "virtual") window.open(`https://www.google.com/maps/place/${value.address}`)
  }

  return (
    <Popover
      value={{
        eventType,
        zoomLink,
        meetingId,
        passcode,
        placeName,
        address
      }}
      onChange={onChange}
      poupStateChange={poupStateChange}
      disabled={disabled}
      onTryToEdit={onTryToEdit}
    >
      {
        (value, popoverOpen) => (
          <div className={`venue-popover ${classes.container} ${popoverOpen && classes.openBorder}`}>
            <div className={classes.thumb} onClick={openLocationInGoogleMap.bind(this, value)}>
              <div>
                {
                  value.eventType === "virtual" ? <>
                    {/* <div className={classes.zoomIcon}>
                      <VideocamIcon fontSize='small' />
                    </div> */}
                    <div className={classes.zoomText}>
                      <img src={ZoomLogo} />
                    </div>
                  </> :
                    <div className={classes.zoomText}>
                      <div>
                        <Icon type={"icon-pin-3"} className={classes.dark} />
                        <div >
                          <Typography type="body1" color="darkBlack">Venue</Typography>
                        </div>
                      </div>
                    </div>
                }
              </div>
            </div>
            <div className={classes.addressContainer}>
              <div className={classes.flexBox}>
                <div className={classes.nameText}>
                  {
                    value.eventType === "virtual" ? "Zoom" : value.placeName
                  }
                </div>
                <div className={"editable-pencil"} >
                  <Icon type="icon-pencil" size="md" />
                </div>

              </div>

              <div className={`${classes.addressText} ${value.eventType === "virtual" ? classes.marginAddressZoom : classes.marginAddressVenue}`} >
                {value.eventType === "virtual" ? value.zoomLink ? parseLink(value.zoomLink) : "" : value.address}
              </div>
            </div>
          </div>
        )
      }

    </Popover>

  )
})

Venue.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default Venue;